import { Image, Button } from 'react-bootstrap'
import ImgVehicleMobile from '../../assets/images/car/vehicle-desktop.svg'
import { useMutation } from 'react-query'

import ServicesMobile from './Services.mobile'
import PhotosMobile from './Photo.mobile'
import { numberFormatCurrency } from '../../utils/helpers'
import { getCarInfo, getServiceLines } from '../../utils/invoice'
import { useApi, useLoading } from '../../hooks'
import toast from '../toast'
import DocumentTop from '../../assets/images/icons/document-top.svg'
import DocumentBot from '../../assets/images/icons/document-bot.svg'

const ViewMobile = ({
  vehicle,
  onShowPhoto,
  record = {},
  isShowSupplement = false,
  isShowParts = false
}) => {
  const { currency = 'usd' } = record
  const { image, year = '', vin = '', stock = '', total = 0, serviceLines = {} } = vehicle
  const { pdfService } = useApi()
	const { isLoading, mutate: downloadPdf } = useMutation(({ recordId, type }) => {
    const services = type === 'parts' ? pdfService.estimatePartsPDF : pdfService.estimateSupplementPDF
    return services({ recordId }, false)
  }, {
		onError: error => toast.error({ title: 'View PDF errors', body: error.message })
	})

  useLoading(isLoading)

  return (
    <div className='mx-4 shadow mt-3'>
      <div className='py-4 px-3'>
        <div className='d-flex'>
          <Image style={{ width: '20%', objectFit: 'contain' }} src={image ? image.replace('color', 'colorCropped') : ImgVehicleMobile} />
          <div className='flex-grow-1 ms-2'>
            <div className='d-flex justify-content-between fs-base'>
              <span>{year}</span>
              <span className='fw-600'>{numberFormatCurrency(currency, total)}</span>
            </div>
            <strong>{getCarInfo(vehicle)}</strong>
            <span className='d-block fs-sub mt-2'>
              <span className='fw-600'>Services: </span>
              <span>{getServiceLines(vehicle)}</span>
            </span>
            <span className='d-block fs-sub'>
              <span className='fw-600'>STOCK/RO: </span>
              <span>{stock || 'None Added'}</span>
            </span>
            <span className='d-block fs-sub'>
              <span className='fw-600'>VIN: </span>
              <span>{vin || 'None Added'}</span>
            </span>
          </div>
        </div>
        {isShowSupplement && (
          <div className='text-center mt-3'>
            <Button
              variant='default'
              onClick={() => downloadPdf({ recordId: record._id, type: 'supplement' })}
              className='text-primary text-uppercase fw-bold mx-auto py-1'>
                View insurance supplement
								<Image src={DocumentTop} className='ms-2'/>
            </Button>
          </div>
          )}

        {isShowParts && (
          <div className='text-center'>
            <Button
              variant='default'
              onClick={() => downloadPdf({ recordId: record._id, type: 'parts' })}
              className='text-primary text-uppercase fw-bold mx-auto py-1'>
                Parts List
								<Image src={DocumentBot} className='ms-2'/>
            </Button>
          </div>
        )}

        {/* services */}
        <ServicesMobile serviceLines={serviceLines} />

        {/* photos */}
        <PhotosMobile onShowPhoto={onShowPhoto} vehicle={vehicle} />
      </div>
    </div>
  )
}

export default ViewMobile
